import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ExtendedSeriesOptionType } from '../../../interfaces/projection';
import { formatAmount } from '../../../utils/renderUtils';
import { MonteCarloChartLegendItem } from './MonteCarloChartLegendItem';

interface IProps {
    chart?: Highcharts.Chart;
    totalSelectedBankableAssets: number;
    seriesData?: ExtendedSeriesOptionType[];
}

export const MonteCarloChartSubHeader: FunctionComponent<IProps> = ({ chart, totalSelectedBankableAssets, seriesData }) => {
    const { t } = useTranslation();

    return (
        <div className="monte-chart-legend">
            <div>
                <MonteCarloChartLegendItem label={t('atProjectionStart')} value={formatAmount(totalSelectedBankableAssets)} />
            </div>
            <div className="monte-chart-legend__end-projection">
                {seriesData?.map((item, index) => {
                    return (
                        <MonteCarloChartLegendItem
                            twr={item.twr}
                            key={item.path}
                            label={index === 0 ? t('atProjectionEnd') : undefined}
                            chart={chart}
                            legendName={item.name}
                            legendColor={item.color as string}
                            legendType={item.type}
                            value={formatAmount(item.amountAtProjectEnd || 0, false, '', true)}
                        />
                    );
                })}
            </div>
        </div>
    );
};
